import { isServer } from '@sravni/vitrina/lib/utils/isServer';

import queue from '../../../../../../utils/queue';

interface IEvent {
  event: 'adEvent' | 'mainEvent' | 'pageViewGA' | string;
  title?: string;
  path?: string;
  eventCategory?: string;
  eventAction?: string;
  eventLabel?: string;
  eventValue?: number;
  'gtm.start'?: number;
}

interface IEventSource {
  event: IEvent['event'];
  eventValue?: IEvent['eventValue'];
  title?: IEvent['title'];
  path?: IEvent['path'];
  eventCategory?: string | string[];
  eventAction?: string | string[];
  eventLabel?: string | string[];
}

interface IAnalyticsWindow extends Window {
  sravniDataLayer: IEvent[];
  yaCounter159737?: {
    getClientID: () => string;
  };
  yaCounter87750877?: {
    getClientID: () => string;
  };
}

declare const window: IAnalyticsWindow;

const getYandexMetricsIdJS = (isWl: boolean) => {
  if (typeof window !== 'undefined') {
    if (isWl) {
      return window.yaCounter87750877 ? window.yaCounter87750877.getClientID() : '';
    }

    return window.yaCounter159737 ? window.yaCounter159737.getClientID() : '';
  }

  return '';
};

export const getYandexMetricsId = (cookie: string, isWl: boolean) => {
  try {
    return cookie || getYandexMetricsIdJS(isWl);
  } catch (_e) {
    return getYandexMetricsIdJS(isWl);
  }
};

export const getGaIdFromCookies = (cookie: string): string => {
  try {
    const [, , part1, part2] = cookie.split('.');

    return `${part1}.${part2}`;
  } catch (_e) {
    return '0000000000.0000000000';
  }
};

const stringifyEventValue = (strings: undefined | string | string[]): string | undefined =>
  Array.isArray(strings) ? strings.join('|') : strings;

// Send data to Data Layer
export const pushGoogleEvent = (event: IEvent): void => {
  if (!isServer) {
    window.sravniDataLayer.push(event);
  }
};

// Push events
export const pushEvent = (event: IEventSource): void => {
  queue.push(() => {
    pushGoogleEvent({
      ...event,
      eventAction: stringifyEventValue(event.eventAction),
      eventLabel: stringifyEventValue(event.eventLabel),
      eventCategory: stringifyEventValue(event.eventCategory),
    });
  });
};

export const makeMainGEvent = (event: Partial<IEventSource>): IEventSource => ({
  eventLabel: undefined,
  eventAction: undefined,
  eventCategory: undefined,
  eventValue: undefined,
  ...event,
  event: 'mainEvent',
});

export const makeAdGEvent = (event: Partial<IEventSource>): IEventSource => ({
  eventLabel: undefined,
  eventAction: undefined,
  eventCategory: undefined,
  eventValue: undefined,
  ...event,
  event: 'adEvent',
});
